import React, { createContext, useState } from 'react';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const SelectionsD1ConferencesStateContext = createContext();

export const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  items: [],
  areItemsLoaded: false,
  orgUnitId: '',
  omeMeetId: ''
};

const SelectionsD1ConferencesContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <SelectionsD1ConferencesStateContext.Provider value={stateHook}>
      {children}
    </SelectionsD1ConferencesStateContext.Provider>
  );
};

export default SelectionsD1ConferencesContextProvider;